export const unauthorizedRedirect = (request) => {
    request.on('response', (result) => {
        if (result.status === 401)
        {
            document.dispatchEvent(new Event('unauthorized'))
            window.location.href = document.body.dataset.loginUrl
        }
    })
}
